export default __webpack_public_path__ + "static/media/vitasmlablogo.d396cb72.png";